import { BoardPermission, BoardType, BoardViewType } from "app/types";
import { GroupByTypeEnum } from "../../../types";
import {
  BoardSettingState,
  DateFormatEnum,
  ExportFormatEnum,
  IBoardsFilters,
  IBoardState,
  TimeFormatEnum,
  WhatToExportEnum,
} from "../types";
import { boardsTicketShortFields } from "./data";

export const initialFilterValues: IBoardsFilters["filters"] = {
  status: [],
  ticketType: [],
  dueDate: [],
  priority: [],
  tags: [],
  release: [],
  targetRelease: [],
  sprint: [],
  environment: [],
  severity: [],
  component: [],
  assignee: [],
  creator: [],
  createdDate: [],
};

export const initialFiltersValues: IBoardsFilters = {
  search: "",
  sort: [],
  filters: { ...initialFilterValues },
  appliedFilterIds: [],
};
export const defaultBoardForm: IBoardState = {
  _id: "",
  name: "",
  description: "",
  viewType: BoardViewType.KANBAN,
  moreDetails: {
    owner: "",
    createdAt: "",
    description: "",
  },
  groupBy: GroupByTypeEnum.NONE,
  visibleGroups: [],
  subGroupBy: GroupByTypeEnum.NONE,
  customizeCards: [],
  permission: BoardPermission.PUBLIC,
  permissionUser: [] as [],
  defaultTicketValues: [],
  defaultTicketType: "",
  Type: BoardType.Custom,
  groups: [],
  groupJson: null,
  filters: {
    search: "",
    sort: [],
    filters: null,
    appliedFilterIds: [],
  },
};

export const initialState: BoardSettingState = {
  isBoardCreate: false,
  isBoardLoading: false,
  boardForm: { ...defaultBoardForm },
  draftBoardForm: { ...defaultBoardForm },
  isBoardUpdate: false,
  ticketDropdownSearchKeyword: "",
  isShownBoardSetting: false,
  isExportingBoard: false,
  exportSettings: {
    format: ExportFormatEnum.CSV,
    whatToExport: WhatToExportEnum.VISIBLE_COLUMNS,
    dateFormat: DateFormatEnum.NORMAL,
    timeFormat: TimeFormatEnum.NORMAL,
  },
  boardDraftFormModal: false,

  boardsShorting: {
    fields: boardsTicketShortFields,
    expanded: true,
    draggedIndex: null,
  },
};
